import { memo, useCallback } from 'react';
import { playButtonSound } from '@wg/web2clientapi/sound';
import { Realm, TableBodyCell, TableRow } from '@wg/wows-react-uikit';

import settings, { hasCrossRealm } from '~/settings';
import { isoToFormattedLocalDateTime } from '~/helpers/datetime';
import { thousands } from '~/helpers/formatting';

import { Clan } from '~/UIKit';

import type { LeagueDivisionRatingType } from '~/Actions/ActionClanRating';
import type { ClanSearchRatingResultItem } from '~/types/declaration';

interface ClansRatingSearchResultTableItemProps {
  clan: ClanSearchRatingResultItem;
  term: string;
  currentAccountClanId?: number;
  currentSeason?: number;
  onClick: (params?: LeagueDivisionRatingType) => void;
}

const ClansRatingSearchResultTableItem = ({
  clan,
  term,
  currentAccountClanId,
  onClick,
}: ClansRatingSearchResultTableItemProps) => {
  const isOwn = currentAccountClanId === clan.id;

  const handleRowClick = useCallback(() => {
    void playButtonSound();

    onClick({
      league: clan.league,
      division: clan.division,
      clanId: clan.id,
      ownClan: false,
    });
  }, [clan.division, clan.id, clan.league, onClick]);

  return (
    <TableRow isHovering isOwn={isOwn} onClick={handleRowClick}>
      {hasCrossRealm && (
        <TableBodyCell modify="left">
          <Realm realm={clan.realm} realmMap={settings.realmsMap} />
        </TableBodyCell>
      )}

      <TableBodyCell modify="basis">
        <Clan
          clanName={clan.name}
          clanTag={clan.tag}
          clanColor={clan.hex_color}
          highlight={term}
          isOwn={isOwn}
          disableTooltip={true}
        />
      </TableBodyCell>

      <TableBodyCell modify="right">{thousands(clan.battles_count)}</TableBodyCell>
      <TableBodyCell modify="right">{isoToFormattedLocalDateTime(clan.last_battle_at)}</TableBodyCell>
      <TableBodyCell modify="right">{clan.members_count}</TableBodyCell>
    </TableRow>
  );
};

export default memo(ClansRatingSearchResultTableItem);
